import React, { useState } from "react";
import AppInputFormik from "src/commun/composants/formulaire/formik/fields/AppInputFormik";
import { useFormikContext } from "formik";
import AppTextareaFormik from "src/commun/composants/formulaire/formik/fields/AppTextareaFormik";
import AppCheckboxFormik from "src/commun/composants/formulaire/formik/fields/AppCheckboxFormik";
import { useAppText } from "src/commun/composants/AppText";
import { AdminPublicite } from "src/domain/AdminPublicite";
import { AppSelectOption } from "src/commun/composants/formulaire/AppSelect/AppSelect";
import AppSelectFormik from "src/commun/composants/formulaire/formik/fields/AppSelectFormik";
import { CAISSE_LIST } from "src/domain/Caisse";


export type AdminPubliciteFormContentProps = {
  services: AppSelectOption[];
  delete(): void;
};


const AdminPubliciteFormContent = ({services,delete: onDelete}:AdminPubliciteFormContentProps) => {
  const { submitCount, submitForm } = useFormikContext<AdminPublicite>();
  const [showConfirmButton, setShowConfirmButton] = useState(false);

  const { tString } = useAppText();
  const supprimer = () => {
    // Call the delete function passed as a prop
    onDelete();
  };
   return (
     <>


       <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
         <AppInputFormik name="id" formulaireSoumis={submitCount > 0} isRequired={false} disabled={true}/>
         <label>{tString("administration.publicite.id")}</label>
       </div>

<br/>
       <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
         <AppInputFormik name="labelFr" formulaireSoumis={submitCount > 0} isRequired={false}/>
         <label>{tString("administration.publicite.labelFr")}</label>
       </div>

       <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
         <AppInputFormik name="labelEn" formulaireSoumis={submitCount > 0} isRequired={false}/>
         <label>{tString("administration.publicite.labelEn")}</label>
       </div>
       <div className="input mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "300px" }}>
         <AppInputFormik name="labelDe" formulaireSoumis={submitCount > 0} isRequired={false}/>
         <label>{tString("administration.publicite.labelDe")}</label>
       </div>

       <div className="textarea mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "100%" }}>
         <AppTextareaFormik name="contenuHtmlFr" formulaireSoumis={submitCount > 0} maxlength={10000} isRequired={false}/>
         <label>{tString("administration.publicite.contenuHtmlFr")}</label>
       </div>

       <div className="textarea mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "100%" }}>
         <AppTextareaFormik name="contenuHtmlEn" formulaireSoumis={submitCount > 0} maxlength={10000} isRequired={false}/>
         <label>{tString("administration.publicite.contenuHtmlEn")}</label>
       </div>

       <div className="textarea mt-3 mb-2 mr-5" style={{ display: "inline-block", width: "100%" }}>
         <AppTextareaFormik name="contenuHtmlDe" formulaireSoumis={submitCount > 0} maxlength={10000} isRequired={false}/>
         <label>{tString("administration.publicite.contenuHtmlDe")}</label>
       </div>

       <div className="mt-3 mb-2" style={{ display: "inline-block", marginRight: "30px", border: "1px solid #d7dce0", padding: "5px" }}>

         <AppCheckboxFormik
           name="flagNew"
           value={"false"}
           label={tString("administration.publicite.flagNew")}/>
       </div>
       <div className="input-box mt-3 mb-2" style={{ display: "inline-block", marginRight: "30px", border: "1px solid #d7dce0", padding: "5px" }}>
         <AppCheckboxFormik
           name="withIcone"
           value={"false"}
           label={tString("administration.publicite.withIcone")}/>
       </div><br/>
       <div className="input mt-6 mb-2 " style={{ display: "inline-block", width: "300px", border: "1px solid #d7dce0", padding: "5px"  }}>
         <AppSelectFormik
           options={
             services
           }
           name="serviceId"
           formulaireSoumis={submitCount > 0}
           defaultValue={""}
         />
       </div>
       <div className="input mt-6 mb-2 " style={{ display: "inline-block", width: "300px", border: "1px solid #d7dce0", padding: "5px"  }}>
         <AppSelectFormik
           options={
             CAISSE_LIST.map(caisse => ({
               value: caisse,
               label: caisse,
             }))
           }
           name="agence"
           formulaireSoumis={submitCount > 0}
           defaultValue={""}
         />

       </div>

       <div className="mt-3 mb-2 mr-5">
         {showConfirmButton ? (
           <>
             <input
               className={`btn__primary mt-3 btn--full--xs`}
               type="button"
               name="confirmDelete"
               onClick={() => {
                 supprimer(); // Call the supprimer function here.
                 setShowConfirmButton(false);
               }}
               style={{ backgroundColor: "red" }}
               value={"Confirmer la suppression"}
             />
           </>
         ) : (
           <>
             <input
               className={`btn__primary mt-3 btn--full--xs mr-5`}
               type="submit"
               name="valider"
               onClick={submitForm}
               value={"Sauvegarder"}
             />
             <input
               className={`btn__secondary mt-3 btn--full--xs`}
               type="button"
               name="supprimer"
               onClick={() => setShowConfirmButton(true)}
               value={"Supprimer"}
             />
           </>
         )}
       </div>

       <hr/>
     </>
   );
};

export default AdminPubliciteFormContent;